import { defineStore } from 'pinia';
import { getVideoWidthAndHeight } from '@/utils/medium';

export const useDesignerStore = defineStore('designer', {
  state: () => {
    return {
      bgVideoUrl: '',
      resolution: null as string | null, // 初始化为null，表示未加载
      video: {
        videoHeadFileUrl: null,
        videoTailFileUrl: null,
        headLine: false,
      },
      videoBgmData: {
        bgmUrl: '',
        musicId: '',
        bgmUrlName: '',
        bgmVolume: 0.5,
      },

      // 编辑器
      ssmlEditor: null,
    };
  },
  getters: {},
  actions: {
    async fetchResolution() {
      try {
        if (this.bgVideoUrl && this.bgVideoUrl.endsWith('.mp4')) {
          const { width, height } = (await getVideoWidthAndHeight(this.bgVideoUrl)) as { width: number; height: number };
          this.resolution = width && height ? `${width}x${height}` : null;
        } else {
          this.resolution = null;
        }
      } catch (error) {
        this.resolution = null;
      }
    },
    setData(key, value) {
      this[key] = value;
      // 如果设置的是bgVideoUrl，尝试获取分辨率
      if (key === 'bgVideoUrl') this.fetchResolution(); // 异步获取分辨率
    },
    initSsmlEditor(ref) {
      this.ssmlEditor = ref;
    },
    initData() {
      this.initVideoBgmDataFn();
      this.initHeadLineFn();
      this.initBgVideoFn();
      this.initVideoFn();
      this.initSsmlEditorFn();
    },
    initVideoBgmDataFn() {
      this.videoBgmData.bgmUrl = '';
      this.videoBgmData.musicId = '';
      this.videoBgmData.bgmUrlName = '';
      this.videoBgmData.bgmVolume = 0.5;
    },
    initHeadLineFn() {
      this.video.headLine = false;
    },
    initBgVideoFn() {
      this.bgVideoUrl = '';
      this.resolution = '';
    },
    initVideoFn() {
      this.video.videoHeadFileUrl = null;
      this.video.videoTailFileUrl = null;
    },
    initSsmlEditorFn() {
      this.ssmlEditor = null;
    },
  },
});
